import Vue from 'vue'
import _ from 'lodash'
import { gaEvent } from '../tools/ga'
import { formatToNumber, formatToPhone } from '../tools/tool.js'

// 只允许输入数字
// v-number:phone - 格式化成123-123-1234
// 利用watch监听值的变化，格式化后重新赋值
Vue.directive('number', {
  bind(el, binding, vnode) {
    if (binding.expression) {
      vnode.context.$watch(binding.expression, (newVal, oldVal) => {
        const v = binding.arg === 'phone' ? formatToPhone(newVal) : formatToNumber(newVal)
        _.set(vnode.context, binding.expression, v)
      })
    }
  }
})

// 回到顶部
Vue.directive('top', {
  inserted(el) {
    el.addEventListener('click', function() {
      document.documentElement.scrollTop = 0
    })
  }
})

// 点击跳转
Vue.directive('to', {
  inserted(el, binding, vnode) {
    el.style.cursor = 'pointer'
    const value = binding.value
    el.addEventListener('click', function() {
      vnode.context.$router.push(value)
    })
  }
})

// ga埋点
Vue.directive('ga', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      gaEvent(binding.value.eventName, binding.value.eventLabel)
    })
  }
})

// ga埋点(传变化的值)
Vue.directive('g', {
  inserted(el, binding, vnode) {
    el.addEventListener('click', () => {
      let eventLabel = ''
      let symbol = ''
      for (const item of binding.value.eventLabel) {
        symbol = binding.value.eventLabel.length - 1 !== binding.value.eventLabel.indexOf(item) ? ', ' : ''
        eventLabel =
          eventLabel +
          (item.key === '' ? '' : item.key + ': ') +
          (binding.value.form ? vnode.context.form[item.value] : vnode.context[item.value]) +
          symbol
      }
      gaEvent(binding.value.eventName, eventLabel)
    })
  }
})
